module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.48705 5.25\">\n  <path d=\"M4.24353,5.25,0,0H8.487Z\"/>\n</svg>\n"